export default "__VITE_ASSET__q811GnVh__"